/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfSystemNetMailMailAddress, SystemNetMailMailAddressFromJSONTyped, SystemNetMailMailAddressToJSON, } from './SystemNetMailMailAddress';
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfSystemNetMailMailAddress(json)) {
        return SystemNetMailMailAddressFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressToJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfSystemNetMailMailAddress(value)) {
        return SystemNetMailMailAddressToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddress.js.map